
import defaultAvatar1 from "../icon/defaultAvatars/user.png";
import defaultAvatar2 from "../icon/defaultAvatars/user1.png";
import defaultAvatar3 from "../icon/defaultAvatars/user2.png";
import defaultAvatar4 from "../icon/defaultAvatars/user3.png";
import defaultAvatar5 from "../icon/defaultAvatars/user4.png";
import defaultAvatar6 from "../icon/defaultAvatars/user5.png";

export const getDateString = (timestamp) => {
	if (!timestamp) return null;

	let date = null;
	if (typeof timestamp === "object" && "seconds" in timestamp) {
		date = new Date(timestamp.seconds * 1000);
		// //console.log("Object")

	} else if (typeof timestamp === "string") {
		date = new Date(timestamp);
		// //console.log("String")
		// //console.log(date);
	}


	const now = new Date();
	const diff = now - date;
	const days = diff / (1000 * 60 * 60 * 24);
	if (days > 7) {
		return date.toLocaleDateString();
	} else if(days < 1){
		return "Today";
	}else {
		return date.toLocaleDateString("en-US", { weekday: "long" });
	}
};

export const getTimeString = (timestamp) => {
	let date = new Date(timestamp);
	return date.toLocaleString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
	});
};


export const getTimeStringMessage = (timestamp) => {
	let date = new Date(timestamp);
	return date.toLocaleString("en-US", {
		hour: "numeric",
		minute: "numeric",
	});
};

export const getAvatar = (url) => {
	if (url && url !== "") return url;
	else return defaultAvatar1;
};

